import React from 'react';
import PropTypes from 'prop-types';
import { find, noop } from 'lodash';

import StepButton from 'build-and-quote/components/Buttons/StepButton.jsx';
import * as Sections from 'build-and-quote/constants/sections.js';

const StepsSection = ({ currentSection, configurationToken, isSingleConfiguration, hasOptions, onPreviousStep }) => {
    let nextSection = find(Sections, ['value', currentSection + 1]);
    let previousSection = find(Sections, ['value', currentSection - 1]);
    let extraClass;
    if (currentSection === Sections.DRIVE_POWER_TRAINS.value) {
        if (isSingleConfiguration && !hasOptions) {
            nextSection = Sections.CONFIRMATION;
        } else if (isSingleConfiguration) {
            nextSection = Sections.OPTIONS_AND_ACCESSORIES;
        }
    }
    if (currentSection === Sections.OPTIONS_PACKAGES.value) {
        if (!hasOptions) {
            nextSection = Sections.CONFIRMATION;
        }
    }
    if (currentSection === Sections.OPTIONS_AND_ACCESSORIES.value) {
        if (isSingleConfiguration) {
            previousSection = Sections.DRIVE_POWER_TRAINS;
        }
    }
    if (currentSection === Sections.CONFIRMATION.value) {
        if (!hasOptions && isSingleConfiguration) {
            previousSection = Sections.DRIVE_POWER_TRAINS;
        } else if (!hasOptions) {
            previousSection = Sections.OPTIONS_PACKAGES;
        }
    }
    if (currentSection === Sections.MODEL_YEARS.value || currentSection === Sections.CONFIRMATION.value) {
        extraClass = 'full';
    }

    const nextStepButton = currentSection > Sections.MODEL_YEARS.value &&
        currentSection < Sections.CONFIRMATION.value && (
            <StepButton nextSection={nextSection} currentSection={currentSection} extraClass={extraClass} />
        );

    const prevStepButton = currentSection > Sections.MODEL_YEARS.value &&
        currentSection < Sections.CONFIRMATION.value &&
        !configurationToken && (
            <StepButton
                nextSection={previousSection}
                currentSection={currentSection}
                extraClass={extraClass}
                onClick={onPreviousStep}
            />
        );

    return (
        <div className="section__next-prev-step bloc-container clearfix">
            <section className="bloc-container-wrapper">
                {prevStepButton}
                {nextStepButton}
            </section>
        </div>
    );
};

StepsSection.defaultProps = {
    configurationToken: '',
    onPreviousStep: noop,
};

StepsSection.propTypes = {
    currentSection: PropTypes.number.isRequired,
    configurationToken: PropTypes.string,
    isSingleConfiguration: PropTypes.bool.isRequired,
    hasOptions: PropTypes.bool.isRequired,
    onPreviousStep: PropTypes.func,
};

StepsSection.displayName = 'StepsSection';

export default StepsSection;
